import { Trans } from '@lingui/macro'

import * as React from 'react'

import { ButtonLarge } from '~ui/components/buttons/ButtonSizes/ButtonLarge'

import { useLayoutCtx } from '../../../config/contexts/LayoutProvider'
import { useAddonDetailControlCtx } from '../contexts/AddonDetailProvider'

type TProps = NoChildren

/**
 * Close button for the addon detail.
 */
export const AddonDetailCloseButton: React.FC<TProps> = () => {
  const { closeAddonDetail } = useAddonDetailControlCtx()
  const { isMobile } = useLayoutCtx()

  return (
    <ButtonLarge
      bgColor={`secondary`}
      onClick={closeAddonDetail}
      width={isMobile ? `100%` : undefined}
    >
      <Trans>Back to product</Trans>
    </ButtonLarge>
  )
}
